import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { HttpMethods } from '@cbre/http';
import { IOption, DefaultSelectionValue, InputProps } from '@miq/shared-models';
import { Observable } from 'rxjs';
import { makeSimpleFormGroup } from '../../utils/simple-form-group';

@Injectable({
  providedIn: 'root',
})
export class SimpleFormGroupService extends HttpMethods {
  constructor(http: HttpClient) {
    super(http);
  }
  /**
   * L2-S5: the body moved to @miq/platform-ui's `makeSimpleFormGroup` - it never touched `this`,
   * and `TreeDataRowComponent` (now in that library) injected this whole HTTP service just to
   * call it. This method stays as the delegating facade so host call sites do not churn.
   */
  makeGroup<T = DefaultSelectionValue>(
    inputProps: InputProps<T>[]
  ): { [fcName: string]: FormControl | FormGroup } {
    return makeSimpleFormGroup<T>(inputProps);
  }
  /**
   * Get submarkets catalog.
   */
  getGeoMarkets(type: string, key: number): Observable<IOption[]> {
    const uri = `/geo/${type}/${key}`;
    return this.httpGet(uri) as Observable<IOption[]>;
  }
}
